<script lang="ts">
  import { requestData } from '$lib/utils/api';
  import { isValidEmail } from '$lib/utils/helpers';
  import Loader from './Loader.svelte';
  
  let email = '';
  let isSubmitting = false;
  let showError = false;
  let showSuccess = false;
  
  async function handleRequest() {
    if (!isValidEmail(email)) {
      showError = true;
      return;
    }
    
    showError = false;
    isSubmitting = true;
    
    const result = await requestData(email);
    
    isSubmitting = false;
    
    if (result.success) {
      showSuccess = true;
    } else {
      showError = true;
    }
  }
</script>

<section id="intro">
  <header>
    <h2 id="q7">Data request</h2>
  </header>

  <p>
    Please enter your email address to request the personal data we may have.
    We will include the data in both human-readable and technical format.
  </p>
  <p>
    You can also use this to obtain a link to unsubscribe and delete
    your data from the game.
  </p>

  {#if !showSuccess}
    <div id="datarequest-area">
      <div>
        <input 
          type="email" 
          bind:value={email}
          placeholder="Email" 
          disabled={isSubmitting}
        />
      </div>
      
      {#if isSubmitting}
        <Loader text="Sending request..." />
      {:else}
        <div id="datarequest-container">
          <button class="button big" on:click={handleRequest}>Request</button>
        </div>
      {/if}
    </div>
    
    {#if showError}
      <div id="datarequest-error" class="error">
        <i class="bi-x-circle-fill"></i> Request failed. Please check the email address.
      </div>
    {/if}
  {:else}
    <div id="datarequest-success">
      <i class="bi-check-circle-fill"></i> Thank you! If we know of that email address, we sent a copy of the data associated with it.
    </div>
  {/if}
</section>

<style>
  #intro {
    padding: 4em;
    background-color: #ffffff;
    border-radius: 4px;
    text-align: center;
  }

  #datarequest-area {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
  }

  #datarequest-area div {
    margin: 0.5em 0.25em;
  }

  #datarequest-area input {
    width: 15em;
  }

  #datarequest-container {
    width: 10em;
  }

  .error {
    color: #ef6480;
    margin: 1em 0 0 0;
  }

  #datarequest-success {
    color: #00aa00;
  }

  @media screen and (max-width: 736px) {
    #intro {
      padding: 2em;
    }
  }

  @media screen and (max-width: 480px) {
    #intro {
      padding: 2em 1em;
    }
  }
</style>
